import { PaymentSuccessResponse } from '@business/entities/organization';
import { gcLabel } from '@core/utils/hooks/misc/gcLabel';
import { t } from 'ttag';

export const REQUEST_MESSAGES = {
  /* fetch */

  fetch_general_error: () => t`Error occured while getting data`,

  fetch_companies_error: () => t`Unable to fetch companies`,
  fetch_automations_error: () => t`Unable to fetch automations`,
  fetch_stats_error: () => t`Unable to fetch stats`,
  connect_nylas_error: () => t`Unable to Connect Nylas`,
  esc_account_error: () => t`Unable to Update Escalate Account`,
  esc_account_saved: () => t`Escalate Account saved successfully`,
  stats_saved: () => t`Stats notification saved successfully`,
  settings_saved: () => t`Settings saved successfully`,
  settings_saved_error: () => t`Unable to save settings`,
  fetch_brands_error: () => t`Unable to fetch brands`,
  fetch_proposal_template_error: () => t`Unable to fetch proposal templates`,
  sort_course_error: () => t`Unable to sort course`,
  fetch_tags_error: () => t`Unable to fetch tags`,
  fetch_webhook_error: () => t`Unable to fetch webhook`,
  fetch_apikey_error: () => t`Unable to fetch api key`,
  fetch_dashboards_error: () => t`Unable to fetch dashboards`,
  fetch_users_error: () => t`Unable to fetch users`,
  fetch_orgs_error: () => t`Unable to fetch ${gcLabel('organizations')}`,
  fetch_pros_error: () => t`Unable to fetch ${gcLabel('projects')}`,
  fetch_contacts_error: () => t`Unable to fetch ${gcLabel('contact')}`,
  fetch_service_error: () => t`Unable to fetch services`,
  fetch_class_error: () => t`Unable to fetch classes`,
  fetch_changelogs_error: () => t`Unable to fetch Changelogs`,
  fetch_tasks_error: () => t`Unable to fetch tasks`,
  fetch_task_links_error: () => t`Unable to fetch task links`,
  parse_error: () => t`Unable to parse file`,

  fetch_timeoffs_error: () => t`Unable to fetch Time offs`,

  fetch_fields_error: () => t`Unable to fetch Custom Fields`,
  fetch_board_error: () => t`Unable to fetch Boards`,
  fetch_order_stages_error: () => t`Unable to fetch order stages`,
  fetch_order_terms_error: () => t`Unable to fetch order terms`,
  fetch_order_vendors_error: () => t`Unable to fetch order suppliers`,
  fetch_order_brands_error: () => t`Unable to fetch order brands`,
  fetch_pricing_tiers_error: () => t`Unable to fetch pricing tiers`,
  fetch_order_products_error: () => t`Unable to fetch order products`,
  fetch_category_error: () => t`Unable to fetch categories`,
  fetch_order_error: () => t`Unable to fetch orders`,
  fetch_commission_period_error: () => t`Unable to fetch commission periods`,

  fetch_pro_templates_error: () => t`Unable to fetch Templates`,
  fetch_error: () => t`Unable to fetch data`,

  fetch_temp_sections_error: () => t`Unable to fetch Sections`,
  fetch_report_error: () => t`Unable to fetch reports`,
  fetch_temp_section_steps_error: () => t`Unable to fetch Steps`,
  update_template_section_sort: () => t`Unable to order sections`,
  update_template_steps_sort: () => t`Unable to order steps`,
  fetch_library_error: () => t`Unable to fetch item`,
  fetch_currency_error: () => t`Unable to fetch currencies`,
  save_step: () => t`Unable to save step information`,

  fetch_project_stage_error: () => t`Unable to fetch ${gcLabel('Project')}  Stages`,

  fetch_imege_finder_error: () => t`Unable to fetch Images`,

  fetch_project_priority_error: () => t`Unable to fetch ${gcLabel('Project')} Priorities`,
  project_order_error: () => t`Unable to set board ordering`,

  fetch_checklists_error: () => t`Unable to fetch checklists`,

  fetch_marketing_boards_error: () => t`Unable to fetch Subscription Boards`,

  fetch_channels_error: () => t`Unable to fetch channels`,
  fetch_ticket_error: () => t`Unable to fetch ticket`,

  fetch_deal_stage_error: () => t`Unable to fetch Stage`,

  deal_order_error: () => t`Unable to set deal order`,

  fetch_form_error: () => t`Unable to fetch Forms`,

  fetch_support_category_error: () => t`Unable to fetch Categories`,

  fetch_activities_error: () => t`Unable to fetch activities`,

  fetch_files_error: () => t`Unable to fetch files`,
  print_file_error: () => t`Unable to downlaod PDF file`,

  fetch_help_articles_error: () => t`Unable to fetch Help Articles`,

  fetch_help_article_categories_error: () => t`Unable to fetch Categories`,

  fetch_help_article_tags_error: () => t`Unable to fetch Tags`,

  fetch_canned_response_error: () => t`Unable to fetch canned responses`,

  fetch_client_projects_error: () => t`Unable to fetch ${gcLabel('Projects')}`,

  fetch_client_project_error: () => t`Unable to fetch ${gcLabel('Project')}`,

  fetch_email_senders: () => t`Unable to fetch email senders`,

  fetch_labels_error: () => t`Unable to fetch labels`,

  fetch_client_forms_error: () => t`Unable to fetch Forms`,

  fetch_reviews_error: () => t`Unable to fetch Reviews`,

  fetch_invoice_settings: () => t`Unable to fetch Invoice Settings`,

  fetch_ai_settings: () => t`Unable to fetch AI Settings`,

  update_checklist_section_sort: () => t`Unable to order sections`,

  update_checklist_steps_sort: () => t`Unable to order steps`,

  fetch_templates_error: () => t`Unable to order sections`,

  fetch_store_error: () => t`Unable to fetch store`,

  move_folder_error: () => t`Unable to move folder`,

  fetch_folder_structure: () => t`Unable to fetch folder structure`,

  fetch_ideas_error: () => t`Unable to fetch ideas`,

  fetch_step: () => t`Unable to fetch Step`,

  fetch_glossaries_error: () => t`Unable to fetch Glossaries`,

  fetch_lineups_error: () => t`Unable to fetch Line-ups`,

  fetch_courses_error: () => t`Unable to fetch courses`,

  fetch_dashboard_emails_error: () => t`Unable to fetch dashboard Emails`,

  fetch_comments_error: () => t`Unable to fetch comments`,

  fetch_commission_groups_error: () => t`Unable to fetch commission groups`,

  fetch_proposal_template_folder: () => t`Unable to fetch folders`,

  fetch_project_template_folder: () => t`Unable to fetch folders`,

  fetch_proposals: () => t`Unable to fetch proposals`,

  fetch_order_packages_error: () => t`Unable to fetch order packages`,

  download_invoice_error: () => t`Unable to download invoice`,

  fetch_phases_error: () => t`Unable to fetch phases`,

  fetch_rma_error: () => t`Unable to fetch RMA`,

  fetch_clockin_error: () => t`Unable to fetch clock in`,
  fetch_clockin_report_error: () => t`Unable to fetch clock in reports`,

  fetch_rma_status_error: () => t`Unable to fetch RMA statuses`,

  fetch_presentations_error: () => t`Unable to fetch presentations`,

  fetch_feedbacks_error: () => t`Unable to fetch feedbacks`,

  fetch_journals_error: () => t`Unable to fetch journals`,

  create_task: () => ({
    success: t`Task created successfully`,
    error: t`Unable to create task`,
  }),

  update_task: () => t`Unable to update task`,

  /* mutation - task links */
  create_task_link_success: () => ({
    success: t`Task link created successfully`,
    error: t`Unable to create task link`,
  }),

  delete_task_link_success: () => ({
    success: t`Task link removed successfully`,
    error: t`Unable to remove task link`,
  }),
  search_entities_error: () => t`Unable to search entities`,
  /* The above code appears to be a comment block in TypeScript. It mentions a function or variable
named "search_entities_error" and asks a question about its purpose or behavior. The comment block
is enclosed within triple hash symbols ( */

  /* mutation - website */

  create_website: () => ({
    success: t`Website created successfully`,
    error: t`Unable to create website`,
  }),

  clone_website: () => ({
    success: t`Website cloned successfully`,
    error: t`Unable to clone website`,
  }),

  update_website: () => ({
    success: t`Website updated successfully`,
    error: t`Unable to update website`,
  }),

  publish_website: () => ({
    success: t`Website published successfully`,
    error: t`Unable to publish website`,
  }),

  reset_website_settings: () => ({
    success: t`Website settings reset successfully`,
    error: t`Unable to reset website settings`,
  }),

  delete_website: () => ({
    success: t`Website deleted successfully`,
    error: t`Unable to delete website`,
  }),

  /* mutation - company */

  create_commission_group: () => ({
    success: t`Commission group created successfully`,
    error: t`Unable to create comission group`,
  }),

  update_commission_group: () => ({
    success: t`Commission group updated successfully`,
    error: t`Unable to update comission group`,
  }),

  delete_commission_group: () => ({
    success: t`Commission group deleted successfully`,
    error: t`Unable to delete comission group`,
  }),

  /* mutation - company */

  create_company: () => ({
    success: t`Company created successfully`,
    error: t`Unable to create company`,
  }),

  create_review: () => ({
    success: t`Review created successfully`,
    error: t`Unable to create review`,
  }),

  update_company: () => ({
    success: t`Company updated successfully`,
    error: t`Unable to update company`,
  }),

  delete_company: () => ({
    success: t`Company deleted successfully`,
    error: t`Unable to delete company`,
  }),

  create_automation: () => ({
    success: t`Automation created successfully`,
    error: t`Unable to create automation`,
  }),

  update_automation: () => ({
    success: t`Automation updated successfully`,
    error: t`Unable to update automation`,
  }),

  delete_automation: () => ({
    success: t`Automation deleted successfully`,
    error: t`Unable to delete automation`,
  }),

  create_filter: () => ({
    success: t`Filter created successfully`,
    error: t`Unable to create filter`,
  }),

  update_filter: () => ({
    success: t`Filter updated successfully`,
    error: t`Unable to update filter`,
  }),

  delete_filter: () => ({
    success: t`Filter deleted successfully`,
    error: t`Unable to delete filter`,
  }),

  /* mutation - brand */
  create_brand: () => ({
    success: t`Brand created successfully`,
    error: t`Unable to create brand`,
  }),

  update_brand: () => ({
    success: t`Brand updated successfully`,
    error: t`Unable to update brand`,
  }),

  delete_brand: () => ({
    success: t`Brand deleted successfully`,
    error: t`Unable to delete brand`,
  }),

  /* mutation - brand */
  create_tag: () => ({
    success: t`Tag created successfully`,
    error: t`Unable to create tag`,
  }),

  update_tag: () => ({
    success: t`Tag updated successfully`,
    error: t`Unable to update tag`,
  }),

  delete_tag: () => ({
    success: t`Tag deleted successfully`,
    error: t`Unable to delete tag`,
  }),

  /* mutation - webhook */
  create_webhook: () => ({
    success: t`Webhook created successfully`,
    error: t`Unable to create webhook`,
  }),

  update_webhook: () => ({
    success: t`Webhook updated successfully`,
    error: t`Unable to update webhook`,
  }),

  delete_webhook: () => ({
    success: t`Webhook deleted successfully`,
    error: t`Unable to delete webhook`,
  }),

  /* mutation - apikey */
  create_apikey: () => ({
    success: t`API key created successfully`,
    error: t`Unable to create api key`,
  }),

  update_apikey: () => ({
    success: t`API key updated successfully`,
    error: t`Unable to update api key`,
  }),

  delete_apikey: () => ({
    success: t`API key deleted successfully`,
    error: t`Unable to delete api key`,
  }),

  /* mutation - brand */
  create_dashboard: () => ({
    success: t`Dashboard created successfully`,
    error: t`Unable to create dashboard`,
  }),

  update_dashboard: () => ({
    success: t`Dashboard updated successfully`,
    error: t`Unable to update dashboard`,
  }),

  delete_dashboard: () => ({
    success: t`Dashboard deleted successfully`,
    error: t`Unable to delete dashboard`,
  }),

  /* mutation - user */
  create_user: () => ({
    success: t`User created successfully`,
    error: t`Unable to create user`,
  }),

  update_user: () => ({
    success: t`User updated successfully`,
    error: t`Unable to update user`,
  }),

  delete_user: () => ({
    success: t`User deleted successfully`,
    error: t`Unable to delete user`,
  }),

  delete_social_account: () => ({
    success: t`Account deleted successfully`,
    error: t`Unable to delete account`,
  }),

  update_social_account: () => ({
    success: t`Account updated successfully`,
    error: t`Unable to update account`,
  }),

  /* mutation - notification settings */
  fetch_notification_settings_error: () => t`Unable to fetch notification settings`,

  update_notification_settings: () => ({
    success: t`Notification settings updated successfully`,
    error: t`Unable to update notification settings`,
  }),

  /* mutation - organization */
  create_organization: () => ({
    success: t`${gcLabel('Organizations')} created successfully`,
    error: t`Unable to create ${gcLabel('organization')}`,
  }),

  update_organization: () => ({
    success: t`${gcLabel('Organization')} updated successfully`,
    error: t`Unable to update ${gcLabel('organization')}`,
  }),

  sync_organization: () => ({
    success: t`${gcLabel('Organization')} has been synced`,
    error: t`Unable to sync ${gcLabel('organization')}`,
  }),

  delete_organization: () => ({
    success: t`${gcLabel('Organization')} deleted successfully`,
    error: t`Unable to delete ${gcLabel('organization')}`,
  }),

  delete_multiple_orgs: () => ({
    success: t`${gcLabel('Organizations')} deleted successfully`,
    error: t`Unable to delete ${gcLabel('organizations')}`,
  }),

  /* mutation - Setting Custom Fields */

  create_field: () => ({
    success: t`Field created successfully`,
    error: t`Unable to create field`,
  }),

  update_field: () => ({
    success: t`Field updated successfully`,
    error: t`Unable to update field`,
  }),

  delete_field: () => ({
    success: t`Field deleted successfully`,
    error: t`Unable to delete field`,
  }),

  /* mutation - Setting Custom Fields */

  create_contact: () => ({
    success: t`${gcLabel('Contact')} created successfully`,
    error: t`Unable to create ${gcLabel('contact')}`,
  }),

  update_contact: () => ({
    success: t`${gcLabel('Contact')} updated successfully`,
    error: t`Unable to update ${gcLabel('contact')}`,
  }),

  delete_contact: () => ({
    success: t`${gcLabel('Contact')} deleted successfully`,
    error: t`Unable to delete ${gcLabel('contact')}`,
  }),

  create_address: () => ({
    success: t`Address created successfully`,
    error: t`Unable to create address`,
  }),

  update_address: () => ({
    success: t`Address updated successfully`,
    error: t`Unable to update address`,
  }),

  delete_address: () => ({
    success: t`Address deleted successfully`,
    error: t`Unable to delete address`,
  }),

  /* mutation - project */
  create_project: () => ({
    success: t`${gcLabel('Project')} created successfully`,
    error: t`Unable to create ${gcLabel('project')}`,
  }),

  update_project: () => ({
    success: t`${gcLabel('Project')} updated successfully`,
    error: t`Unable to update ${gcLabel('project')}`,
  }),

  delete_project: () => ({
    success: t`${gcLabel('Project')} canceled successfully`,
    error: t`Unable to cancel ${gcLabel('project')}`,
  }),

  /* mutation - project */
  create_service: () => ({
    success: t`Service created successfully`,
    error: t`Unable to create service`,
  }),

  update_service: () => ({
    success: t`Service updated successfully`,
    error: t`Unable to update service`,
  }),

  active_service: () => ({
    success: t`Service made active successfully`,
    error: t`Unable to active service`,
  }),

  deactive_service: () => ({
    success: t`Service made inactive successfully`,
    error: t`Unable to deactive service`,
  }),

  create_class: () => ({
    success: t`Class created successfully`,
    error: t`Unable to create class`,
  }),

  update_class: () => ({
    success: t`Class updated successfully`,
    error: t`Unable to update class`,
  }),

  delete_class: () => ({
    success: t`Class deleted successfully`,
    error: t`Unable to delete class`,
  }),

  /* mutation - board */
  create_board: () => ({
    success: t`Board created successfully`,
    error: t`Unable to create board`,
  }),

  update_board: () => ({
    success: t`Board updated successfully`,
    error: t`Unable to update board`,
  }),

  delete_board: () => ({
    success: t`Board deleted successfully`,
    error: t`Unable to delete board`,
  }),

  save_integration: () => ({
    success: t`Integration saved successfully`,
    error: t`Unable to save Integration`,
  }),

  delete_integration: () => ({
    success: t`Integration deleted successfully`,
    error: t`Unable to delete Integration`,
  }),

  create_payment: () => ({
    success: t`Payment method created successfully`,
    error: t`Unable to create payment method`,
  }),
  update_payment: () => ({
    success: t`Payment method updated successfully`,
    error: t`Unable to update payment method`,
  }),

  delete_payment: () => ({
    success: t`Payment method deleted successfully`,
    error: t`Unable to update payment method`,
  }),

  refund_payment: () => ({
    success: t`Payment refunded successfully`,
    error: t`Unable to refund payment`,
  }),

  /* mutation - project Template */
  create_project_template: () => ({
    success: t`Template created successfully`,
    error: t`Unable to create template`,
  }),

  update_project_template: () => ({
    success: t`Template updated successfully`,
    error: t`Unable to update template`,
  }),

  delete_project_template: () => ({
    success: t`Template deleted successfully`,
    error: t`Unable to delete template`,
  }),

  duplicate_project_template: () => ({
    success: t`Template duplicated successfully`,
    error: t`Unable to duplicate template`,
  }),

  move_project_template: () => ({
    success: t`Template moved successfully`,
    error: t`Unable to move template`,
  }),

  move_item: () => ({
    success: t`Item moved successfully`,
    error: t`Unable to move item`,
  }),

  search_items: () => t`Unable to search items`,

  fetch_folder: () => t`Unable to fetch folder`,

  create_folder: () => ({
    success: t`Folder created successfully`,
    error: t`Unable to create folder`,
  }),

  update_folder: () => ({
    success: t`Folder updated successfully`,
    error: t`Unable to update folder`,
  }),

  delete_folder: () => ({
    success: t`Folder deleted successfully`,
    error: t`Unable to delete folder`,
  }),

  fetch_breadcrumbs: () => t`Unable to fetch breadcrumbs`,

  /* mutation - project Template Sections*/
  create_template_section: () => ({
    success: t`Section created successfully`,
    error: t`Unable to create section`,
  }),

  update_template_section: () => ({
    success: t`Section updated successfully`,
    error: t`Unable to update section`,
  }),

  delete_template_section: () => ({
    success: t`Section deleted successfully`,
    error: t`Unable to delete section`,
  }),

  /* mutation - project Template Section Steps*/
  create_template_section_step: () => ({
    success: t`Step created successfully`,
    error: t`Unable to create step`,
  }),
  create_template_section_step_error: () => t`Unable to create step`,

  update_template_section_step: () => ({
    success: t`Step updated successfully`,
    error: t`Unable to update step`,
  }),

  delete_template_section_step: () => ({
    success: t`Step deleted successfully`,
    error: t`Unable to delete step`,
  }),

  /* mutation - project Stage */
  create_project_stage: () => ({
    success: t`${gcLabel('Project')} Stage created successfully`,
    error: t`Unable to create ${gcLabel('project')} stage`,
  }),

  update_project_stage: () => ({
    success: t`${gcLabel('Project')} Stage updated successfully`,
    error: t`Unable to update ${gcLabel('project')} stage`,
  }),

  delete_project_stage: () => ({
    success: t`${gcLabel('Project')} Stage deleted successfully`,
    error: t`Unable to delete ${gcLabel('project')} stage`,
  }),

  /* mutation - project Stage */
  create_project_priority: () => ({
    success: t`${gcLabel('Project')} Priority created successfully`,
    error: t`Unable to create ${gcLabel('project')} priority`,
  }),

  update_project_priority: () => ({
    success: t`${gcLabel('Project')} Priority updated successfully`,
    error: t`Unable to update ${gcLabel('project')} priority`,
  }),

  delete_project_priority: () => ({
    success: t`${gcLabel('Project')} Priority deleted successfully`,
    error: t`Unable to delete ${gcLabel('project')} priority`,
  }),

  default_project_priority: () => ({
    success: t`Priority has been set as default`,
    error: t`Unable to make priority default`,
  }),

  remove_default_project_priority: () => ({
    success: t`Default priority has been removed successfully`,
    error: t`Unable to remove priority default`,
  }),

  project_invoice: () => ({
    success: t`Invoice has been sent successfully`,
    error: t`Unable to send invoice`,
  }),

  project_process_payment: () => ({
    success: t`Payment has been processed successfully`,
    error: t`Unable to process payment`,
  }),

  project_process_payment_cc: (response: { data?: PaymentSuccessResponse; error?: any }) => ({
    success: response.data?.message || t`Payment has been processed successfully`,
    error: t`Unable to process payment`,
  }),
  /* mutation - project Template Section Steps*/
  create_marketing_checklist: () => ({
    success: t`Checklist created successfully`,
    error: t`Unable to create checklist`,
  }),

  update_marketing_checklist: () => ({
    success: t`Checklist updated successfully`,
    error: t`Unable to update checklist`,
  }),

  delete_marketing_checklist: () => ({
    success: t`Checklist deleted successfully`,
    error: t`Unable to delete checklist`,
  }),

  duplicate_marketing_checklist: () => ({
    success: t`Checklist Duplicated successfully`,
    error: t`Unable to duplicate checklist`,
  }),

  /* mutation - project Checklist Sections*/
  create_checklist_section: () => ({
    success: t`Section created successfully`,
    error: t`Unable to create section`,
  }),

  update_checklist_section: () => ({
    success: t`Section updated successfully`,
    error: t`Unable to update section`,
  }),

  delete_checklist_section: () => ({
    success: t`Section deleted successfully`,
    error: t`Unable to delete section`,
  }),

  /* mutation - project Checklist Section Steps*/
  create_checklist_section_step: () => ({
    success: t`Step created successfully`,
    error: t`Unable to create step`,
  }),

  update_checklist_section_step: () => ({
    success: t`Step updated successfully`,
    error: t`Unable to update step`,
  }),

  delete_checklist_section_step: () => ({
    success: t`Step deleted successfully`,
    error: t`Unable to delete step`,
  }),

  save_settings: () => ({
    success: t`Settings saved successfully`,
    error: t`Unable to save Settings`,
  }),

  /* mutation - Marketing Board*/
  save_marketing_board_settings: () => ({
    success: t`Settings saved successfully`,
    error: t`Unable to save Settings`,
  }),

  market_board_step_completed: () => ({
    success: t`Step Completed successfully`,
    error: t`Unable to complete the step`,
  }),

  market_board_step_incompleted: () => ({
    success: t`Settings saved successfully`,
    error: t`Unable to save description`,
  }),

  /* mutation - Marketing Board Note*/
  create_marketing_board_note: () => ({
    success: t`Note created successfully`,
    error: t`Unable to create note`,
  }),

  update_marketing_board_note: () => ({
    success: t`Note updated successfully`,
    error: t`Unable to update note`,
  }),

  delete_marketing_board_note: () => ({
    success: t`Note deleted successfully`,
    error: t`Unable to delete note`,
  }),

  marketing_services: () => ({
    success: t`Marketing services has been updated successfully`,
    error: t`Unable to update marketing services`,
  }),

  create_subscription: () => ({
    success: t`New subscription has been created successfully`,
    error: t`Unable to create subscription`,
  }),

  update_subscription: () => ({
    success: t`Subscription has been updated successfully`,
    error: t`Unable to update subscription`,
  }),

  create_sub_invoice: () => ({
    success: t`Subscription payment has been created successfully`,
    error: t`Unable to create subscription payment`,
  }),

  cancel_subscription: () => ({
    success: t`Subscription has been cancelled`,
    error: t`Unable to cancel subscription`,
  }),

  sync_subscription: () => ({
    success: t`Subscription has been synced`,
    error: t`Unable to sync subscription`,
  }),

  manual_support_time: () => ({
    success: t`Manual ${gcLabel('Support')} Time has been submitted`,
    error: t`Unable to submit ${gcLabel('support')} time`,
  }),

  validate_domain_dns: () => ({
    success: t`Domain DNS records have been updated`,
    error: t`Unable to update dns`,
  }),

  /* mutation - Channel*/
  create_channel: () => ({
    success: t`Channel updated successfully`,
    error: t`Unable to update channel`,
  }),

  update_channel: () => ({
    success: t`Channel updated successfully`,
    error: t`Unable to update channel`,
  }),

  delete_channel: () => ({
    success: t`Channel deleted successfully`,
    error: t`Unable to delete channel`,
  }),

  /** Tickets */

  create_ticket: () => ({
    success: t`Ticket created successfully`,
    error: t`Unable to create ticket`,
  }),

  update_ticket: () => ({
    success: t`Ticket updated successfully`,
    error: t`Unable to update ticket`,
  }),

  update_tickets: () => ({
    success: t`Tickets updated successfully`,
    error: t`Unable to update tickets`,
  }),

  delete_ticket: () => ({
    success: t`Channel deleted successfully`,
    error: t`Unable to delete ticket`,
  }),

  create_ticket_reply: () => ({
    success: t`Reply sent successfully`,
    error: t`Unable to create reply`,
  }),
  create_ticket_note: () => ({
    success: t`Internal note sent successfully`,
    error: t`Unable to create internal note`,
  }),

  update_ticket_reply: () => ({
    success: t`Reply updated successfully`,
    error: t`Unable to updated reply`,
  }),

  delete_ticket_reply: () => ({
    success: t`Reply deleted successfully`,
    error: t`Unable to deleted reply`,
  }),

  status_update: () => ({
    success: t`Status updated successfully`,
    error: t`Unable to update status`,
  }),

  /** Deal */

  create_deal: () => ({
    success: t`${gcLabel('Deal')} created successfully`,
    error: t`Unable to create ${gcLabel('deal')}`,
  }),
  update_deal: () => ({
    success: t`${gcLabel('Deal')} updated successfully`,
    error: t`Unable to update ${gcLabel('deal')}`,
  }),
  delete_deal: () => ({
    success: t`${gcLabel('Deal')} deleted successfully`,
    error: t`Unable to delete ${gcLabel('deal')}`,
  }),

  deal_status: () => ({
    success: t`${gcLabel('Deal')} status updated successfully`,
    error: t`Unable to update ${gcLabel('deal')}`,
  }),

  create_deal_board: () => ({
    success: t`${gcLabel('Deal')} Board created successfully`,
    error: t`Unable to create ${gcLabel('Deal')} Board`,
  }),
  update_deal_board: () => ({
    success: t`${gcLabel('Deal')} Board updated successfully`,
    error: t`Unable to update ${gcLabel('Deal')} Board`,
  }),
  delete_deal_board: () => ({
    success: t`${gcLabel('Deal')} Board deleted successfully`,
    error: t`Unable to delete ${gcLabel('Deal')} Board`,
  }),
  duplicate_deal_board: () => ({
    success: t`${gcLabel('Deal')} Board duplicated successfully`,
    error: t`Unable to duplicate ${gcLabel('Deal')} Board`,
  }),

  create_deal_stage: () => ({
    success: t`${gcLabel('Deal')} Stage created successfully`,
    error: t`Unable to create ${gcLabel('Deal')} Board`,
  }),
  update_deal_stage: () => ({
    success: t`${gcLabel('Deal')} Stage updated successfully`,
    error: t`Unable to update ${gcLabel('Deal')} Board`,
  }),
  delete_deal_stage: () => ({
    success: t`${gcLabel('Deal')} Stage deleted successfully`,
    error: t`Unable to delete ${gcLabel('Deal')} Board`,
  }),

  create_deal_lost_reason: () => ({
    success: t`${gcLabel('Deal')} Lost Reason created successfully`,
    error: t`Unable to create ${gcLabel('Deal')} Board`,
  }),
  update_deal_lost_reason: () => ({
    success: t`${gcLabel('Deal')} Lost Reason updated successfully`,
    error: t`Unable to update ${gcLabel('Deal')} Board`,
  }),
  delete_deal_lost_reason: () => ({
    success: t`${gcLabel('Deal')} Lost Reason deleted successfully`,
    error: t`Unable to delete ${gcLabel('Deal')} Board`,
  }),

  /* mutation - Form*/
  create_form: () => ({
    success: t`Form created successfully`,
    error: t`Unable to create form`,
  }),

  update_form: () => ({
    success: t`Form updated successfully`,
    error: t`Unable to update form`,
  }),

  delete_form: () => ({
    success: t`Form deleted successfully`,
    error: t`Unable to delete form`,
  }),

  clone_form: () => ({
    success: t`Form cloned successfully`,
    error: t`Unable to clone form`,
  }),

  save_form_fields: () => ({
    success: t`Form Fields saved successfully`,
    error: t`Unable to save form fields`,
  }),

  /* mutation - Form*/
  create_support_category: () => ({
    success: t`Category created successfully`,
    error: t`Unable to create category`,
  }),

  update_support_category: () => ({
    success: t`Category updated successfully`,
    error: t`Unable to update category`,
  }),

  delete_support_category: () => ({
    success: t`Category deleted successfully`,
    error: t`Unable to delete category`,
  }),

  /* mutation - Form*/
  create_activity: () => ({
    success: t`Activity created successfully`,
    error: t`Unable to create activity`,
  }),

  update_activity: () => ({
    success: t`Activity updated successfully`,
    error: t`Unable to update activity`,
  }),

  delete_activity: () => ({
    success: t`Activity deleted successfully`,
    error: t`Unable to delete activity`,
  }),

  /* mutation - Canned*/
  create_canned: () => ({
    success: t`Canned response created successfully`,
    error: t`Unable to create response`,
  }),

  update_canned: () => ({
    success: t`Canned response updated successfully`,
    error: t`Unable to update response`,
  }),

  delete_canned: () => ({
    success: t`Canned response deleted successfully`,
    error: t`Unable to delete response`,
  }),

  create_folder: () => ({
    success: t`Folder created successfully`,
    error: t`Unable to create folder`,
  }),

  rename_folder: () => ({
    success: t`Folder renamed successfully`,
    error: t`Unable to rename folder`,
  }),

  download_folder: () => ({
    success: t`Folder zip will be sent your email in 10 minutes`,
    error: t`Unable to download folder`,
  }),

  delete_folder: () => ({
    success: t`Folder deleted successfully`,
    error: t`Unable to delete folder`,
  }),

  rename_file: () => ({
    success: t`File renamed successfully`,
    error: t`Unable to rename file`,
  }),

  delete_revision: () => ({
    success: t`Revision deleted successfully`,
    error: t`Unable to delete revision`,
  }),

  sync_to_ai98: () => ({
    success: t`Revision synced to AI98 successfully`,
    error: t`Unable to sync revision to AI98`,
  }),

  rename_revision: () => ({
    success: t`Revision renamed successfully`,
    error: t`Unable to rename firevisionle`,
  }),

  delete_file: () => ({
    success: t`File deleted successfully`,
    error: t`Unable to delete file`,
  }),

  create_document: () => ({
    success: t`Document created successfully`,
    error: t`Unable to create document`,
  }),

  create_form_file: () => ({
    success: t`Form created successfully`,
    error: t`Unable to create form`,
  }),

  save_form_values: () => ({
    success: t`Form updated successfully`,
    error: t`Unable to update form`,
  }),

  reset_checklist: () => ({
    success: t`Checklists are reset successfully`,
    error: t`Unable to reset checklists`,
  }),

  create_help_article: () => ({
    success: t`Help Article created successfully`,
    error: t`Unable to create Help Article`,
  }),
  update_help_article: () => ({
    success: t`Help Article updated successfully`,
    error: t`Unable to update Help Article`,
  }),
  delete_help_article: () => ({
    success: t`Help Article deleted successfully`,
    error: t`Unable to delete Help Article`,
  }),

  create_help_article_category: () => ({
    success: t`Category created successfully`,
    error: t`Unable to create Category`,
  }),
  update_help_article_category: () => ({
    success: t`Category updated successfully`,
    error: t`Unable to update Category`,
  }),
  delete_help_article_category: () => ({
    success: t`Category deleted successfully`,
    error: t`Unable to delete Category`,
  }),

  create_help_article_tag: () => ({
    success: t`Tag created successfully`,
    error: t`Unable to create Tag`,
  }),

  store_help_article_feedback: () => ({
    success: t`Feedback saved successfully`,
    error: t`Unable to save feedback`,
  }),

  fill_form: () => ({
    success: t`Form saved successfully`,
    error: t`Unable to update form`,
  }),

  share_form: () => ({
    success: t`Form shared successfully`,
    error: t`Unable to update form`,
  }),

  store_duplicate: () => ({
    success: t`Store duplicated successfully`,
    error: t`Unable to duplicate store`,
  }),

  /** Time Log Messages */
  fetch_time_log_error: () => t`Unable to fetch Time Logs`,
  time_tracker_start_error: () => t`Unable to time tracker`,

  start_time_log: () => ({
    success: t`Time Tracker has started successfully`,
    error: t`Unable to start tracker`,
  }),
  stop_time_log: () => ({
    success: t`Time Log has been saved successfully`,
    error: t`Unable to save tracked time`,
  }),
  manual_time_log: () => ({
    success: t`Manual time has been added successfully`,
    error: t`Unable to save Manual time`,
  }),
  update_manual_time_log: () => ({
    success: t`Manual time has been updated successfully`,
    error: t`Unable to save Manual time`,
  }),
  delete_time_log: () => ({
    success: t`Time log deleted successfully`,
    error: t`Unable to delete Time log`,
  }),
  create_email_sender: () => ({
    success: t`Email sender created successfully`,
    error: t`Unable to create email sender`,
  }),
  update_email_sender: () => ({
    success: t`Email sender updated successfully`,
    error: t`Unable to update email sender`,
  }),
  delete_email_sender: () => ({
    success: t`Email sender deleted successfully`,
    error: t`Unable to delete email sender`,
  }),

  /** Timeline Email Messages */
  send_email: () => ({
    success: t`Email sent successfully`,
    error: t`Unable to send Email`,
  }),
  send_email_reply: () => ({
    success: t`Reply sent successfully`,
    error: t`Unable to send Reply`,
  }),

  /** Media Share */
  fetch_media_error: () => t`Unable to fetch media`,

  create_media: () => ({
    success: t`Media created successfully`,
    error: t`Unable to create media`,
  }),
  update_media: () => ({
    success: t`Media updated successfully`,
    error: t`Unable to update media`,
  }),
  delete_media: () => ({
    success: t`Media deleted successfully`,
    error: t`Unable to delete media`,
  }),
  /** Teams */
  fetch_teams_error: () => t`Unable to fetch teams`,
  create_team: () => ({
    success: t`Team created successfully`,
    error: t`Unable to create team`,
  }),

  update_team: () => ({
    success: t`Team updated successfully`,
    error: t`Unable to update team`,
  }),

  delete_team: () => ({
    success: t`Team deleted successfully`,
    error: t`Unable to delete team`,
  }),

  change_owner: () => ({
    success: t`Owner has been updated successfully`,
    error: t`Unable to update owner`,
  }),

  create_step_comment: () => ({
    success: t`Comment created successfully`,
    error: t`Unable to create comment`,
  }),

  /** Comments start */

  create_comment: () => ({
    success: t`Comment created successfully`,
    error: t`Unable to create comment`,
  }),
  update_comment: () => ({
    success: t`Comment updated successfully`,
    error: t`Unable to update comment`,
  }),
  delete_comment: () => ({
    success: t`Comment deleted successfully`,
    error: t`Unable to delete comment`,
  }),
  /** Comments end */

  folder_visibility: () => ({
    success: t`Folder visibility changed successfully`,
    error: t`Unable to rename folder`,
  }),

  file_visibility: () => ({
    success: t`File visibility changed successfully`,
    error: t`Unable to rename folder`,
  }),

  update_label: () => ({
    success: t`Label updated successfully`,
    error: t`Unable to update label`,
  }),

  update_contact_timezone: () => ({
    success: t`Time Zone updated successfully`,
    error: t`Unable to update timezone`,
  }),

  sync_task_to_clickup: () => ({
    success: t`Task synced to clickup successfully`,
    error: t`Unable to sync task to clickup`,
  }),

  unsync_task_from_clickup: () => ({
    success: t`Task unsynced from clickup successfully`,
    error: t`Unable to unsync task from clickup`,
  }),

  create_review_reply: () => ({
    success: t`Replied successfully`,
    error: t`Unable to reply`,
  }),

  save_invoice_settings: () => ({
    success: t`Settings updated successfully`,
    error: t`Unable to update settings`,
  }),

  save_ai_settings: () => ({
    success: t`Settings updated successfully`,
    error: t`Unable to update settings`,
  }),

  process_payment: () => ({
    success: t`Payment has been processed`,
    error: t`Unable to process Payment`,
  }),

  /* mutation - Checklist */
  create_checklist: () => ({
    success: t`Checklist created successfully`,
    error: t`Unable to create checklist`,
  }),

  update_checklist: () => ({
    success: t`Checklist updated successfully`,
    error: t`Unable to update checklist`,
  }),

  delete_checklist: () => ({
    success: t`Checklist deleted successfully`,
    error: t`Unable to delete checklist`,
  }),

  duplicate_checklist: () => ({
    success: t`Checklist duplicated successfully`,
    error: t`Unable to duplicate checklist`,
  }),

  execute_template: () => ({
    success: t`Template executed successfully`,
    error: t`Unable to execute template`,
  }),

  /* mutation - checklist Sections*/
  create_checklist_gc_section: () => ({
    success: t`Section created successfully`,
    error: t`Unable to create section`,
  }),

  update_checklist_gc_section: () => ({
    success: t`Section updated successfully`,
    error: t`Unable to update section`,
  }),

  delete_checklist_gc_section: () => ({
    success: t`Section deleted successfully`,
    error: t`Unable to delete section`,
  }),

  /* mutation - checklist Section Steps*/
  create_checklist_gc_section_step: () => ({
    success: t`Step created successfully`,
    error: t`Unable to create step`,
  }),

  update_checklist_gc_section_step: () => ({
    success: t`Step updated successfully`,
    error: t`Unable to update step`,
  }),

  delete_checklist_gc_section_step: () => ({
    success: t`Step deleted successfully`,
    error: t`Unable to delete step`,
  }),

  create_course_section: () => t`Unable to create section`,

  update_course_section: () => t`Unable to update section`,

  delete_course_section: () => t`Unable to delete section`,

  /* mutation - checklist Section Steps*/
  create_course_section_step: () => t`Unable to create step`,

  update_course_section_step: () => t`Unable to update step`,

  delete_course_section_step: () => t`Unable to delete step`,

  enroll_course_item: () => ({
    success: t`Enrolled successfully`,
    error: t`Unable to Enrolled`,
  }),

  invite_course_users: () => ({
    success: t`Users invited successfully`,
    error: t`Unable to invite users`,
  }),

  /* mutation - Library Folder Item*/
  create_folder_item: () => ({
    success: t`Item created successfully`,
    error: t`Unable to create Item`,
  }),

  update_folder_item: () => ({
    success: t`Item updated successfully`,
    error: t`Unable to update Item`,
  }),

  delete_folder_item: () => ({
    success: t`Item deleted successfully`,
    error: t`Unable to delete Item`,
  }),

  /* mutation - Store Folder Item*/
  create_store: () => ({
    success: t`Store created successfully`,
    error: t`Unable to create store`,
  }),

  update_store: () => ({
    success: t`Store updated successfully`,
    error: t`Unable to update store`,
  }),

  delete_store: () => ({
    success: t`Store deleted successfully`,
    error: t`Unable to delete store`,
  }),

  /* mutation - Store Line Item*/
  create_store_line_item: () => ({
    success: t`Line Item created successfully`,
    error: t`Unable to create line item`,
  }),

  update_store_line_item: () => ({
    success: t`Line Item updated successfully`,
    error: t`Unable to update line item`,
  }),

  delete_store_line_item: () => ({
    success: t`Line Item deleted successfully`,
    error: t`Unable to delete line item`,
  }),

  /* mutation - stages */
  create_order_stage: () => ({
    success: t`Order stage created successfully`,
    error: t`Unable to create stage`,
  }),

  update_order_stage: () => ({
    success: t`Order stage updated successfully`,
    error: t`Unable to update stage`,
  }),

  delete_order_stage: () => ({
    success: t`Order stage deleted successfully`,
    error: t`Unable to delete stage`,
  }),

  /* mutation - terms */
  create_order_term: () => ({
    success: t`Term created successfully`,
    error: t`Unable to create term`,
  }),

  update_order_term: () => ({
    success: t`Term updated successfully`,
    error: t`Unable to update term`,
  }),

  delete_order_term: () => ({
    success: t`Term deleted successfully`,
    error: t`Unable to delete term`,
  }),

  /* mutation - vendor */
  create_order_vendor: () => ({
    success: t`Supplier created successfully`,
    error: t`Unable to create supplier`,
  }),

  update_order_vendor: () => ({
    success: t`Supplier updated successfully`,
    error: t`Unable to update supplier`,
  }),

  delete_order_vendor: () => ({
    success: t`Supplier deleted successfully`,
    error: t`Unable to delete supplier`,
  }),

  /* mutation - vendor */

  /* mutation - brand */
  create_order_brand: () => ({
    success: t`Brand created successfully`,
    error: t`Unable to create brand`,
  }),

  update_order_brand: () => ({
    success: t`Brand updated successfully`,
    error: t`Unable to update brand`,
  }),

  delete_order_brand: () => ({
    success: t`Brand deleted successfully`,
    error: t`Unable to delete brand`,
  }),

  create_pricing_tier: () => ({
    success: t`Pricing tier created successfully`,
    error: t`Unable to create pricing tier`,
  }),

  update_pricing_tier: () => ({
    success: t`Pricing tier updated successfully`,
    error: t`Unable to update pricing tier`,
  }),

  delete_pricing_tier: () => ({
    success: t`Pricing tier deleted successfully`,
    error: t`Unable to delete pricing tier`,
  }),

  /* mutation - product */
  create_order_product: () => ({
    success: t`Product created successfully`,
    error: t`Unable to create product`,
  }),

  update_order_product: () => ({
    success: t`Product updated successfully`,
    error: t`Unable to update product`,
  }),
  sync_order_product: () => ({
    success: t`Products synced successfully`,
    error: t`Unable to sync Products`,
  }),

  delete_order_product: () => ({
    success: t`Product deleted successfully`,
    error: t`Unable to delete product`,
  }),
  /** Order */
  create_order: () => ({
    success: t`Order created successfully`,
    error: t`Unable to create order`,
  }),

  update_order: () => ({
    success: t`Order updated successfully`,
    error: t`Unable to update order`,
  }),

  send_customer_statement: () => ({
    success: t`Customer statement sent successfully`,
    error: t`Unable to send customer statement`,
  }),

  accept_order: () => ({
    success: t`Order accepted successfully`,
    error: t`Unable to accept order`,
  }),

  reject_order: () => ({
    success: t`Order rejected successfully`,
    error: t`Unable to reject order`,
  }),

  delete_order: () => ({
    success: t`Order deleted successfully`,
    error: t`Unable to delete order`,
  }),

  send_purchase_order: () => ({
    success: t`Purchase order sent successfully`,
    error: t`Unable to send purchase order`,
  }),

  close_purchase_order: () => ({
    success: t`Purchase order closed successfully`,
    error: t`Unable to close purchase order`,
  }),

  update_order_status: () => ({
    success: t`Order has updated successfully`,
    error: t`Unable to update order`,
  }),

  /** Category */
  create_category: () => ({
    success: t`Category created successfully`,
    error: t`Unable to create category`,
  }),

  update_category: () => ({
    success: t`Category updated successfully`,
    error: t`Unable to update category`,
  }),
  sync_category: () => ({
    success: t`Categories synced successfully`,
    error: t`Unable to sync Categories`,
  }),

  delete_category: () => ({
    success: t`Category deleted successfully`,
    error: t`Unable to delete category`,
  }),

  /** Data Sources */
  fetch_report_source_error: () => t`Unable to fetch Data Sources`,
  create_report_source: () => ({
    success: t`Data Source created successfully`,
    error: t`Unable to create Data Source`,
  }),

  update_report_source: () => ({
    success: t`Data Source updated successfully`,
    error: t`Unable to update Data Source`,
  }),

  delete_report_source: () => ({
    success: t`Data Source deleted successfully`,
    error: t`Unable to delete Data Source`,
  }),

  /** */

  update_shipment: () => ({
    success: t`Shipment updated successfully`,
    error: t`Unable to update shipment`,
  }),

  delete_shipment: () => ({
    success: t`Shipment deleted successfully`,
    error: t`Deleted to update shipment`,
  }),

  delete_invoice: () => ({
    success: t`Invoice deleted successfully`,
    error: t`Unable to delete invoice`,
  }),

  /* mutation - Idea*/
  create_idea: () => ({
    success: t`Idea created successfully`,
    error: t`Unable to create idea`,
  }),

  update_idea: () => ({
    success: t`Idea updated successfully`,
    error: t`Unable to update idea`,
  }),

  delete_idea: () => ({
    success: t`Idea deleted successfully`,
    error: t`Unable to delete idea`,
  }),

  /* mutation - Feedback*/
  feedback_idea: () => ({
    success: t`Feedback submitted successfully`,
    error: t`Unable to submit feedback`,
  }),

  /* mutation - Idea Comment*/
  create_idea_comment: () => ({
    success: t`Comment created successfully`,
    error: t`Unable to create comment`,
  }),

  update_idea_comment: () => ({
    success: t`Comment updated successfully`,
    error: t`Unable to update comment`,
  }),

  delete_idea_comment: () => ({
    success: t`Comment deleted successfully`,
    error: t`Unable to delete comment`,
  }),

  idea_vote: () => ({
    success: t`Vote saved successfully`,
    error: t`Unable to save vote`,
  }),

  org_merge: () => ({
    success: t`${gcLabel('Organizations')} have been merged successfully`,
    error: t`Unable to merge organizations`,
  }),

  contact_merge: () => ({
    success: t`${gcLabel('Contacts')} have been merged successfully`,
    error: t`Unable to merge contacts`,
  }),

  invoice_void: () => ({
    success: t`Invoice is voided successfully`,
    error: t`Unable to void invoice`,
  }),

  duplicate_library_item: () => ({
    success: t`Item duplicated successfully`,
    error: t`Unable to duplicate item`,
  }),

  settings_updated: () => ({
    success: t`Settings updated successfully`,
    error: t`Unable to update settings`,
  }),

  org_export: () => ({
    success: t`Export job has been queued`,
    error: t`Unable to export`,
  }),

  create_report: () => ({
    success: t`Report created successfully`,
    error: t`Unable to create report`,
  }),
  update_report: () => ({
    success: t`Report updated successfully`,
    error: t`Unable to update report`,
  }),
  copy_report: () => ({
    success: t`Report duplicated successfully`,
    error: t`Unable to duplicate report`,
  }),
  delete_report: () => ({
    success: t`Report deleted successfully`,
    error: t`Unable to delete report`,
  }),

  fetch_jobs_error: () => t`Unable to fetch active jobs`,
  dismiss_job_error: () => t`Unable to dismiss current job`,

  /* start mutation - Changelogs */
  create_changelog: () => ({
    success: t`Changelog created successfully`,
    error: t`Unable to create Changelog`,
  }),

  update_changelog: () => ({
    success: t`Changelog updated successfully`,
    error: t`Unable to update Changelog`,
  }),

  delete_changelog: () => ({
    success: t`Changelog deleted successfully`,
    error: t`Unable to delete Changelog`,
  }),
  /* end mutation - Changelogs */

  /* mutation - Glossaries*/
  create_glossary: () => ({
    success: t`Glossary created successfully`,
    error: t`Unable to create glossary`,
  }),

  update_glossary: () => ({
    success: t`Glossary updated successfully`,
    error: t`Unable to update glossary`,
  }),

  delete_glossary: () => ({
    success: t`Glossary deleted successfully`,
    error: t`Unable to delete glossary`,
  }),

  /* mutation - Glossaries*/

  /* mutation - Courses*/
  create_course: () => ({
    success: t`Course created successfully`,
    error: t`Unable to create course`,
  }),

  sort_course: () => ({
    success: t`Course sorted successfully`,
    error: t`Unable to sort course`,
  }),

  duplicate_course: () => ({
    success: t`Course copied successfully`,
    error: t`Unable to copied course`,
  }),

  update_course: () => ({
    success: t`Course updated successfully`,
    error: t`Unable to update course`,
  }),

  unarchive_course: () => ({
    success: t`Course is Un-archive successfully`,
    error: t`Unable to un-archive course`,
  }),

  archive_course: () => ({
    success: t`Course is Archived successfully`,
    error: t`Unable to archive course`,
  }),

  unpublish_course: () => ({
    success: t`Course is Unpublished successfully`,
    error: t`Unable to unpublish course`,
  }),

  publish_course: () => ({
    success: t`Course is Published successfully`,
    error: t`Unable to publish course`,
  }),

  delete_course: () => ({
    success: t`Course deleted successfully`,
    error: t`Unable to delete course`,
  }),

  /* mutation - Courses*/

  /* mutation - Lineups*/
  create_lineup: () => ({
    success: t`Line-up created successfully`,
    error: t`Unable to create line-up`,
  }),

  update_lineup: () => ({
    success: t`Line-up updated successfully`,
    error: t`Unable to update line-up`,
  }),

  delete_lineup: () => ({
    success: t`Line-up deleted successfully`,
    error: t`Unable to delete line-up`,
  }),

  remove_course: () => ({
    success: t`Course removed successfully`,
    error: t`Unable to remove course`,
  }),

  save_commission: () => ({
    success: t`Commission saved successfully`,
    error: t`Unable to save commission`,
  }),

  fetch_commission_error: () => t`Unable to fetch Commissions`,
  sub_compare: () => t`Unable to run report`,

  create_subscription_board: () => ({
    success: t`${gcLabel('Subscription')} Board created successfully`,
    error: t`Unable to create ${gcLabel('Subscription')} Board`,
  }),
  update_subscription_board: () => ({
    success: t`${gcLabel('Subscription')} Board updated successfully`,
    error: t`Unable to update ${gcLabel('Subscription')} Board`,
  }),
  delete_subscription_board: () => ({
    success: t`${gcLabel('Subscription')} Board deleted successfully`,
    error: t`Unable to delete ${gcLabel('Subscription')} Board`,
  }),

  /* mutation - Lineups*/

  /* mutation - Dashboard Emails */
  create_dashboard_email: () => ({
    success: t`Dashboard email created successfully`,
    error: t`Unable to create dashboard email`,
  }),

  update_dashboard_email: () => ({
    success: t`Dashboard email updated successfully`,
    error: t`Unable to update dashboard email`,
  }),

  delete_dashboard_email: () => ({
    success: t`Dashboard email deleted successfully`,
    error: t`Unable to delete dashboard email`,
  }),
  /* mutation - Dashboard Emails */

  share_project: () => ({
    success: t`Project shared successfully!`,
    error: t`Unable to share project`,
  }),

  create_marketing_board: () => ({
    success: t`Organization added on board successfully`,
    error: t`Unable to create marketing board`,
  }),
  delete_marketing_board: () => ({
    success: t`Board deleted successfully`,
    error: t`Unable to delete board`,
  }),
  create_marketing_board_checklist: () => ({
    success: t`Checklist added successfully`,
    error: t`Unable to create checklist`,
  }),

  update_marketing_board_checklist: () => ({
    success: t`Checklist updated successfully`,
    error: t`Unable to update checklist`,
  }),

  error_on_section: () => t`Unable to create section`,
  /* mutation - Recurring Checklist Section*/
  create_recurring_checklist_section: () => ({
    success: t`Checklist section created successfully`,
    error: t`Unable to checklist section`,
  }),

  update_recurring_checklist_section: () => ({
    success: t`Checklist section updated successfully`,
    error: t`Unable to update checklist section`,
  }),

  delete_recurring_checklist_section: () => ({
    success: t`Checklist Section deleted successfully`,
    error: t`Unable to delete checklist section`,
  }),

  /* mutation - Recurring Checklist Section step*/
  create_recurring_checklist_section_step: () => ({
    success: t`Checklist section created successfully`,
    error: t`Unable to checklist section step`,
  }),

  update_recurring_checklist_section_step: () => ({
    success: t`Checklist section step updated successfully`,
    error: t`Unable to update checklist section step`,
  }),

  delete_recurring_checklist_section_step: () => ({
    success: t`Checklist section step deleted successfully`,
    error: t`Unable to delete checklist section step`,
  }),

  /* mutation - Setup Checklist Section step*/
  create_setup_checklist_section_step: () => ({
    success: t`Setup section created successfully`,
    error: t`Unable to setup section step`,
  }),

  update_setup_checklist_section_step: () => ({
    success: t`Setup section step updated successfully`,
    error: t`Unable to update setup section step`,
  }),

  delete_setup_checklist_section_step: () => ({
    success: t`Step deleted successfully`,
    error: t`Unable to delete step`,
  }),

  step_updated: () => ({
    success: t`Step updated successfully`,
    error: t`Unable to update step`,
  }),

  /* mutation - brand */
  resend_proposal: () => ({
    success: t`Proposal resent successfully`,
    error: t`Unable to reset proposal`,
  }),

  create_proposal_template: () => ({
    success: t`Template created successfully`,
    error: t`Unable to create template`,
  }),

  update_proposal_template: () => ({
    success: t`Template updated successfully`,
    error: t`Unable to update template`,
  }),

  change_status_template: () => ({
    success: t`Status updated successfully`,
    error: t`Unable to update status`,
  }),

  delete_proposal_template: () => ({
    success: t`Template archived successfully`,
    error: t`Unable to archive template`,
  }),

  hard_delete_proposal: () => ({
    success: t`Proposal deleted successfully`,
    error: t`Unable to delete proposal`,
  }),

  undelete_proposal_template: () => ({
    success: t`Template unarchived successfully`,
    error: t`Unable to unarchive template`,
  }),

  /* mutation - brand */
  create_proposal_template_folder: () => ({
    success: t`Folder created successfully`,
    error: t`Unable to create folder`,
  }),

  update_proposal_template_folder: () => ({
    success: t`Folder updated successfully`,
    error: t`Unable to update folder`,
  }),

  delete_proposal_template_folder: () => ({
    success: t`Folder deleted successfully`,
    error: t`Unable to delete folder`,
  }),

  /* mutation - project template folder */
  create_project_template_folder: () => ({
    success: t`Folder created successfully`,
    error: t`Unable to create folder`,
  }),

  update_project_template_folder: () => ({
    success: t`Folder updated successfully`,
    error: t`Unable to update folder`,
  }),

  delete_project_template_folder: () => ({
    success: t`Folder deleted successfully`,
    error: t`Unable to delete folder`,
  }),

  /* mutation - brand */
  create_proposal: () => ({
    success: t`Proposal created successfully`,
    error: t`Unable to create proposal`,
  }),

  update_proposal: () => ({
    success: t`Proposal updated successfully`,
    error: t`Unable to update proposal`,
  }),

  duplicate_proposal: () => ({
    success: t`Proposal duplicated successfully`,
    error: t`Unable to duplicate proposal`,
  }),

  delete_proposal: () => ({
    success: t`Proposal archived successfully`,
    error: t`Unable to archive proposal`,
  }),

  unarchive_proposal: () => ({
    success: t`Proposal Unarchived successfully`,
    error: t`Unable to Unarchive proposal`,
  }),

  /* mutation - package */
  create_order_package: () => ({
    success: t`Package created successfully`,
    error: t`Unable to create package`,
  }),

  update_order_package: () => ({
    success: t`Package updated successfully`,
    error: t`Unable to update package`,
  }),

  sync_order_package: () => ({
    success: t`Packages synced successfully`,
    error: t`Unable to sync packages`,
  }),

  delete_order_package_product: () => ({
    success: t`Package product removed successfully`,
    error: t`Unable to delete package product`,
  }),

  delete_order_package: () => ({
    success: t`Package deleted successfully`,
    error: t`Unable to delete package`,
  }),

  /* mutation - package */
  create_labour_type: () => ({
    success: t`Type created successfully`,
    error: t`Unable to create type`,
  }),

  update_labour_type: () => ({
    success: t`Type updated successfully`,
    error: t`Unable to update type`,
  }),

  delete_labour_type_product: () => ({
    success: t`Type product removed successfully`,
    error: t`Unable to delete type`,
  }),

  delete_labour_type: () => ({
    success: t`Type deleted successfully`,
    error: t`Unable to delete type`,
  }),

  /* mutation - Time Material Time Tracking */
  create_time_tracking: () => ({
    success: t`Time Tracked successfully`,
    error: t`Unable to create type`,
  }),

  update_time_tracking: () => ({
    success: t`Time Track updated successfully`,
    error: t`Unable to update type`,
  }),

  delete_time_tracking: () => ({
    success: t`Time Track removed successfully`,
    error: t`Unable to delete type`,
  }),

  create_task_status: () => ({
    success: t`Task Status created successfully`,
    error: t`Unable to create task status`,
  }),

  update_task_status: () => ({
    success: t`Task Status updated successfully`,
    error: t`Unable to update task status`,
  }),

  delete_task_status: () => ({
    success: t`Task Status deleted successfully`,
    error: t`Unable to delete task status`,
  }),

  project_step_priority: () => t`Unable to update priority`,
  two_factor_setup: () => t`Unable to send code`,
  verify_two_factor: () => t`The code you entered is invalid`,

  two_factor: () => ({
    success: t`Two factor authentication enabled successfully`,
    error: t`The code you entered is invalid`,
  }),

  two_factor_disable: () => ({
    success: t`Two factor authentication disabled successfully`,
    error: t`Unable to disable two factor authentication`,
  }),

  copy_proposal_template_block: () => ({
    success: t`Block copied successfully`,
    error: t`Unable to copy the block`,
  }),

  /* mutation - universal sections */
  create_universal_section: () => ({
    success: t`Universal section created successfully`,
    error: t`Unable to create universal section`,
  }),

  update_universal_section: () => ({
    success: t`Universal section updated successfully and changes propagated`,
    error: t`Unable to update universal section`,
  }),

  delete_universal_section: () => ({
    success: t`Universal section deleted successfully`,
    error: t`Unable to delete universal section`,
  }),

  duplicate_universal_section: () => ({
    success: t`Universal section duplicated successfully`,
    error: t`Unable to duplicate universal section`,
  }),

  create_tm_phase: () => ({
    success: t`Phase created successfully`,
    error: t`Unable to create phase`,
  }),

  update_tm_phase: () => ({
    success: t`Phase updated successfully`,
    error: t`Unable to update phase`,
  }),

  delete_tm_phase: () => ({
    success: t`Phase deleted successfully`,
    error: t`Unable to delete phase`,
  }),

  create_work_order: () => ({
    success: t`Work order created successfully`,
    error: t`Unable to create work order`,
  }),
  vendasta_subscribe: () => ({
    success: t`Thank you subscribing`,
    error: t`Unable to process your request`,
  }),

  tm_receive_items: () => ({
    success: t`Request sent successfully!`,
    error: t`Unable to receive items`,
  }),

  create_change_order: () => ({
    success: t`Board created successfully`,
    error: t`Unable to create board`,
  }),

  update_change_order: () => ({
    success: t`Change order updated successfully`,
    error: t`Unable to update change order`,
  }),

  delete_change_order: () => ({
    success: t`Change order deleted successfully`,
    error: t`Unable to delete change order`,
  }),

  create_clockin: () => t`Unable to clock-in`,

  stop_clockin: () => ({
    success: t`Clocked out successfully`,
    error: t`Unable to clock out`,
  }),

  update_clockin: () => ({
    success: t`Clockin updated successfully`,
    error: t`Unable to update clockin`,
  }),

  delete_clockin: () => ({
    success: t`Clockin deleted successfully`,
    error: t`Unable to delete clockin`,
  }),

  manual_clockin: () => ({
    success: t`Manual Clockin added successfully`,
    error: t`Unable to add manual clockin`,
  }),
  unlink_proposal: () => ({
    success: t`Proposal unlinked successfully`,
    error: t`Unable to unlink proposal`,
  }),

  create_rma_status: () => ({
    success: t`Status created successfully`,
    error: t`Unable to create status`,
  }),

  update_rma_status: () => ({
    success: t`Status updated successfully`,
    error: t`Unable to update status`,
  }),

  delete_rma_status: () => ({
    success: t`Status deleted successfully`,
    error: t`Unable to delete status`,
  }),

  create_rma_phase: () => ({
    success: t`RMA created successfully`,
    error: t`Unable to create RMA`,
  }),

  update_rma_phase: () => ({
    success: t`RMA updated successfully`,
    error: t`Unable to update RMA`,
  }),

  delete_rma_phase: () => ({
    success: t`RMA deleted successfully`,
    error: t`Unable to delete RMA`,
  }),

  po_status_updated: () => ({
    success: t`PO status updated successfully`,
    error: t`Unable to PO status`,
  }),

  update_po_status_success: () => ({
    success: t`PO status updated successfully`,
    error: t`Unable to update PO status`,
  }),

  update_time_log_billable: () => ({
    success: t`Timelog updated successfully`,
    error: t`Unable to update timelog`,
  }),

  create_presentation: () => ({
    success: t`Presentation created successfully`,
    error: t`Unable to create presentation`,
  }),

  update_presentation: () => ({
    success: t`Presentation updated successfully`,
    error: t`Unable to update presentation`,
  }),

  duplicate_presentation: () => ({
    success: t`Presentation updated successfully`,
    error: t`Unable to update presentation`,
  }),

  delete_presentation: () => ({
    success: t`Presentation deleted successfully`,
    error: t`Unable to delete presentation`,
  }),

  create_timeoff: () => ({
    success: t`Timeoff created successfully`,
    error: t`Unable to create timeoff`,
  }),

  update_timeoff: () => ({
    success: t`Timeoff updated successfully`,
    error: t`Unable to update timeoff`,
  }),

  delete_timeoff: () => ({
    success: t`Timeoff deleted successfully`,
    error: t`Unable to delete timeoff`,
  }),
  sync_invoice: () => ({
    success: t`Invoice synced successfully`,
    error: t`Unable to sync invoice`,
  }),
  archive_form: () => ({
    success: t`Form archived successfully`,
    error: t`Unable to archive form`,
  }),

  /* mutation - journal */
  create_journal: () => ({
    success: t`Journal created successfully`,
    error: t`Unable to create journal`,
  }),

  update_journal: () => ({
    success: t`Journal updated successfully`,
    error: t`Unable to update journal`,
  }),

  delete_journal: () => ({
    success: t`Journal deleted successfully`,
    error: t`Unable to delete journal`,
  }),

  like_journal: () => ({
    success: t`Journal liked successfully`,
    error: t`Unable to like journal`,
  }),

  dislike_journal: () => ({
    success: t`Journal disliked successfully`,
    error: t`Unable to dislike journal`,
  }),

  fetch_journal_error: () => t`Unable to fetch journal`,

  save_manual_commission: () => ({
    success: t`Commission saved successfully`,
    error: t`Unable to save commission`,
  }),

  update_manual_commission: () => ({
    success: t`Commission updated successfully`,
    error: t`Unable to update commission`,
  }),

  delete_manual_commission: () => ({
    success: t`Commission deleted successfully`,
    error: t`Unable to delete commission`,
  }),

  save_split_overrides: () => ({
    success: t`Commission splits updated successfully`,
    error: t`Unable to update commission splits`,
  }),
  fetch_split_overrides: () => t`Unable to fetch commission splits`,
};
